import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import {
  ElementRef,
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { SubmitHandler } from "react-hook-form";
import { ToastContentProps, toast } from "react-toastify";
import StoreNoteModal from "../../StoreNoteModal";
import { useStoreCompanyCourseNoteMutation } from "@/services/companies/courses/notes";
import { NoteForm } from "@/interfaces/Note";

interface StoreCompanyCourseModalMethods {
  showOrHiddenModal: (ids?: [string, string]) => void;
}

const StoreCompanyCourseNoteModal: ForwardRefRenderFunction<
  StoreCompanyCourseModalMethods
> = (_, ref) => {
  const [ids, setIds] = useState<[string, string]>();
  const StoreNoteModalRef = useRef<ElementRef<typeof StoreNoteModal>>(null);
  const [storeCompanyCourseNoteAsync] = useStoreCompanyCourseNoteMutation();

  const showOrHiddenModal = (ids?: [string, string]) => {
    setIds(ids);
    StoreNoteModalRef.current?.showOrHiddenModal();
  };

  useImperativeHandle(ref, () => ({
    showOrHiddenModal,
  }));

  const onSubmit: SubmitHandler<NoteForm> = async (data) => {
    toast.promise(
      storeCompanyCourseNoteAsync([ids![0], ids![1], data]).unwrap(),
      {
        pending: "Ajout de la note en cours...",
        success: {
          render() {
            showOrHiddenModal();
            return (
              <p style={{ marginBottom: 0, textAlign: "center" }}>
                La note à bien été ajoutée 🤩
              </p>
            );
          },
        },
        error: {
          render({ data }: ToastContentProps<FetchBaseQueryError>) {
            if (data?.status === 422) {
              return "Les champs que vous avez remplis semblent être incorrects.";
            }

            return "Une erreur est survenue";
          },
        },
      }
    );
  };

  return <StoreNoteModal ref={StoreNoteModalRef} onSubmit={onSubmit} />;
};

export default forwardRef(StoreCompanyCourseNoteModal);
